<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-password-recovery"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <form autocomplete="off">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/sbt-caravanas-logo.png"
                  alt="login"
                  class="w-1/2 m-auto"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Recuperar Senha</h4>
                  </div>

                  <div>
                    <vs-row class="">
                      <vs-col class="w-1/4"
                        ><vs-input
                          name="ddd"
                          id="ddd"
                          v-mask="'##'"
                          label-placeholder="DDD"
                          v-model="form.ddd"
                          pattern="[0-9]*"
                          class="w-2/3"
                          maxlength="2"
                          data-vv-as="'DDD'"
                          v-validate="'required|digits:2'"
                      /></vs-col>
                      <vs-col class="w-3/4"
                        ><vs-input
                          name="mobile"
                          id="mobile"
                          type="tel"
                          v-mask="'#########'"
                          label-placeholder="Celular"
                          v-model="form.mobile"
                          pattern="[0-9]*"
                          class="w-full"
                          maxlength="9"
                          data-vv-as="'Celular'"
                          v-validate="'required|digits:9'"
                      /></vs-col>
                    </vs-row>
                    <vs-row v-show="errors.has('ddd') || errors.has('mobile')">
                      <vs-col>
                        <span
                          v-show="errors.has('ddd')"
                          class="text-danger text-sm"
                          id="ddd-error"
                          >{{ errors.first('ddd') }}</span
                        >
                        <span
                          v-show="errors.has('mobile')"
                          class="text-danger text-sm"
                          id="mobile-error"
                          >{{ errors.first('mobile') }}</span
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row>
                      <vs-col class="w-half"
                        ><vs-input
                          label="CPF"
                          v-model="form.cpf"
                          type="tel"
                          class="mt-1 w-full"
                          id="cpf"
                          name="cpf"
                          v-mask="'###.###.###-##'"
                          data-vv-as="'CPF'"
                          v-validate="'required|cpf'"
                      /></vs-col>
                      <vs-col class="w-half"
                        ><vs-input
                          label="RG"
                          v-model="form.rg"
                          maxlength="14"
                          type="text"
                          class="mt-1 w-full"
                          id="rg"
                          name="rg"
                          data-vv-as="'RG'"
                          v-validate="'required|min:7|max:14'"
                      /></vs-col>
                    </vs-row>
                    <vs-row
                      v-show="errors.has('cpf') || errors.has('rg')"
                      class="mt-1 mb-2"
                    >
                      <vs-col v-show="errors.has('cpf')" class="w-full">
                        <span class="text-danger text-sm" id="cpf-error">{{
                          errors.first('cpf')
                        }}</span>
                      </vs-col>
                      <vs-col v-show="errors.has('rg')" class="w-full">
                        <span
                          class="text-danger w-full text-sm"
                          id="rg-error"
                          >{{ errors.first('rg') }}</span
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row>
                      <vs-col class="w-half">
                        <vs-input
                          label="Data de nascimento"
                          v-model="form.birthdate"
                          type="tel"
                          class="mt-1 w-full"
                          id="birthdate"
                          name="birthdate"
                          v-mask="'##/##/####'"
                          data-vv-as="'Data de nascimento'"
                          v-validate="
                            `required|date_format:dd/MM/yyyy|date_between:01/01/1910,${today}`
                          "
                      /></vs-col>
                      <vs-col class="w-half">
                        <vs-input
                          label="CEP Residêncial"
                          v-model="form.cep"
                          type="tel"
                          class="mt-1 w-full"
                          id="cep"
                          name="cep"
                          v-mask="'#####-###'"
                          data-vv-as="'CEP'"
                          v-validate="'required|min:9|max:9'"
                      /></vs-col>
                    </vs-row>
                    <vs-row
                      v-show="errors.has('birthdate') || errors.has('cep')"
                      class="mt-1 mb-2"
                    >
                      <vs-col class="w-full" v-show="errors.has('birthdate')">
                        <span
                          class="text-danger text-sm"
                          id="birthdate-error"
                          >{{ errors.first('birthdate') }}</span
                        >
                        <vs-col class="w-full" v-show="errors.has('cep')">
                          <span class="text-danger text-sm" id="cep-error">{{
                            errors.first('cep')
                          }}</span>
                        </vs-col>
                      </vs-col>
                    </vs-row>

                    <vs-row v-show="errorMsg" class="mt-1 mb-2">
                      <vs-col class="w-full">
                        <span
                          id="message-error"
                          class="text-danger w-full text-sm"
                          >{{ errorMsg }}</span
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row class="mt-3 mb-2">
                      <vs-col class="w-full">
                        <vs-button
                          @click="recoverPassword"
                          :disabled="!isButtonReady"
                          class="float-right"
                          id="button-with-loading"
                          >Recuperar</vs-button
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row class="mt-5 w-full flex">
                      <vs-col class="ml-auto flex">
                        <router-link to="/" class="ml-auto flex login-link">
                          <span class="text">Acessar Sistema</span>
                        </router-link>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { strings } from '@/utils/strings'
import { mask } from 'vue-the-mask'
import axios from '@/axios.js'

export default {
  data() {
    return {
      form: {
        ddd: '11',
        mobile: '',
        cpf: '',
        rg: '',
        birthdate: '',
        cep: '',
        password: '',
      },
      errorMsg: null,
    }
  },
  directives: { mask },
  computed: {
    today() {
      return new Date()
        .toISOString()
        .substr(0, 10)
        .split('-')
        .reverse()
        .join('/')
    },
    isButtonReady() {
      return (
        !this.errors.any() &&
        this.form.ddd &&
        this.form.mobile &&
        this.form.cpf &&
        this.form.rg &&
        this.form.birthdate &&
        this.form.cep
      )
    },
  },
  methods: {
    setLoadingContained(value = true) {
      if (value === true) {
        this.setErrorMsg('')
        this.$vs.loading({
          background: 'primary',
          color: '#FFF',
          container: '#button-with-loading',
          scale: 0.45,
        })
        this.isLoadingActive = true
      } else {
        this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        this.isLoadingActive = false
      }
    },
    convertDate(value) {
      return value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')
    },
    clearNumber(value) {
      return value.replace(/[^\d]/g, '')
    },
    async recoverPassword() {
      this.setLoadingContained(true)

      let password = this.form.password + '=='

      const { ddd, mobile, cpf, rg, birthdate, cep } = {
        ...this.form,
      }

      const payload = {
        mobile: this.clearNumber(ddd + '' + mobile),
        cpf: this.clearNumber(cpf),
        rg: this.clearNumber(rg),
        birthdate: this.convertDate(birthdate),
        cep: this.clearNumber(cep),
      }

      try {
        this.errorMsg = ''

        await axios
          .post(`users/resetPassword`, payload)
          .then((response) => {
            this.showMsg(
              'Senha alterada para os 4 primeiros dígitos de seu CPF!'
            )
            setTimeout(() => {
              this.$router.push('/')
            }, 2500)
          })
          .catch((err) => {
            this.showMsg(err, true)
          })
          .finally(() => {
            this.setLoadingContained(false)
          })
      } catch (err) {
        this.setLoadingContained(false)
      }
    },
    extractMsg(err, error = false) {
      let message = 'Ocorreu um erro. Tente novamente'

      if (err) {
        if (err.response && err.response.data) {
          err = err.response.data
        }

        if (err.errors && err.errors[0].message) {
          message =
            strings['pt-br'][err.errors[0].message] || err.errors[0].message
        } else if (err.message) {
          message = strings['pt-br'][err.message] || err.message
        } else if (strings['pt-br'][err]) {
          message = strings['pt-br'][err]
        } else {
          message = err
        }
      }

      return message
    },
    setErrorMsg(err) {
      this.errorMsg = this.extractMsg(err)
    },
    showMsg(msg, error = false) {
      const content = this.extractMsg(msg, error)

      this.setErrorMsg(msg)

      this.$vs.notify({
        text: content,
        color: error ? 'danger' : 'success',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        time: 20000,
        position: 'bottom-left',
      })
    },
    mounted() {
      this.setLoadingContained(false)
    },
    created() {
      this.setLoadingContained(true)
    },
  },
}
</script>

<style lang="scss">
#page-password-recovery {
  .text-danger.text-sm {
    display: block;
    width: 100%;
  }
  .vs-input.vs-input-primary {
    min-width: 38px;
  }
  @media screen and (min-width: 720px) {
    form {
      .w-half {
        width: 50% !important;
        &:nth-of-type(1) {
          .w-full {
            padding-right: 0.5em !important;
          }
        }
        &:nth-of-type(2) {
          .w-full {
            padding-left: 0.5em !important;
          }
        }
      }
    }
  }
  .w-full.text-sm {
    float: left;
    clear: both;
    & + .text-sm {
      margin-top: 16px;
    }
  }
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
  #password {
    -webkit-text-security: disc;
  }
}
</style>
